import React, { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../../context/AuthContext";
import { ChatContext } from "../../context/ChatContext";
import parse from "html-react-parser";

export default function Message({ message }) {
  const { currentUser } = useContext(AuthContext);
  const { data, members } = useContext(ChatContext);
  const ref = useRef();

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true, // Include AM/PM indicator
    });
  
    return `${formattedDate} ${formattedTime}`;
  }

  function getImage() {
    let index = members.findIndex((item) => item.uid == message.senderId);
    if (index !== -1) {
      return members[index].photoURL;
    } else
      return "https://i.ibb.co/KWvYHpX/360-F-64676383-Ldbmhi-NM6-Ypzb3-FM4-PPu-FP9r-He7ri8-Ju.jpg";
  }

  
  useEffect(() => {
    ref.current?.scrollIntoView({ behaviour: "smooth" });
  }, [message]);

  return (
    <div
      ref={ref}
      className={`message ${message.senderId === currentUser.uid && "owner"}`}
    >
      <div className="messageInfo">
        <img
          src={
            message.senderId === currentUser.uid
              ? currentUser.photoURL
              : data.user.isGroup
              ? getImage()
              : data.user.photoURL
          }
          alt="profile"
        />
        <span className="msgDate" style={{fontSize:"10px",alignItems: "flex-end"}}>{formatTimestamp(message.date)}</span>
      </div>
      <div className="messageContent">
        {message.text && <>{parse(message.text)}</>}
        {message.img && <img src={message.img} alt="" />}
      </div>
    </div>
  );
}
